import React from "react"

export function BodyWrapper({children}: React.PropsWithChildren){
    return (
        <div className="h-full pt-36 pb-16 px-7 flex-grow flex flex-col">
            {children}
        </div>
    )
}